module.exports = __webpack_public_path__ + "img/vives.bb9d2ebc.svg";